module.exports = __webpack_public_path__ + "img/image1.81948295.png";